module.exports = __webpack_public_path__ + "img/3-claim-entity-selection.9f44367d.png";